export default __webpack_public_path__ + "static/stage-2_7-8a31e2ba885826d3806901159bd1b6b4.jpg";